// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"360":"79d4a651","502":"dec4c112","533":"01372747"}[chunkId] + ".chunk.css";
};